import { MinusCircleOutlined, PlusCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { NodeAccessOperation } from '@prisma/client';
import { Tag, theme } from 'antd';

export type ProfileOperationRendererProps = {
  operation?: NodeAccessOperation | null;
};

export const ProfileOperationRenderer = ({ operation }: ProfileOperationRendererProps) => {
  const { token } = theme.useToken();

  let color = '#8c8c8c';
  let label = 'Unknown';
  let icon = <QuestionCircleOutlined />;

  switch (operation) {
    case NodeAccessOperation.ADD:
      color = token.green7;
      label = 'Add';
      icon = <PlusCircleOutlined />;
      break;
    case NodeAccessOperation.DELETE:
      color = token.orange6;
      label = 'Delete';
      icon = <MinusCircleOutlined />;
      break;
    default:
      break;
  }

  return (
    <Tag color={color} icon={icon}>
      {label}
    </Tag>
  );
};
